'use strict'

//import * as polybool from 'polybooljs';
import { Edge, trapezoidation } from './polygonTrapezoidation';
import { intersectLinePolygon, polygonArea, rotatePolygon, rotatePolygons, intersectLineLine2, removeSpikes, removeCollinearPoints, isPointInPolygon, simplifyPolygonWithBuffer, simplePolygonBuffer, removeNearPoints, trapezoidsToJsts, simplifyAndNormalizePolygon, ringToGeojsonPolygon } from './geometry';
import {connectedComponents } from 'graphology-components';
import {Graph} from 'graphology';
import { distancePointPoint} from './geometry';

//var simplepolygon = require('simplepolygon');


export default function getSubFields3(params){

    var polygonsUtm = params.polygonsUtm;
    var turningRadius = 1; // (m)
    var workingWidth = params.workingWidth; // (m)
    var workingSpeed = params.workingSpeed; // (m/s)
    var turningTime = params.turningTime; // (s)
    var headlandWidth = 1; // (m)   // -1 for variable headland width (depending on border/track angle)
    var areaCostCoefficient = params.areaCostCoefficient;
    var timeCostCoefficient = params.timeCostCoefficient;
    var thresholdRightAngle = params.thresholdRightAngle; // (degrees)
    var thresholdCollinearAngle = params.thresholdCollinearAngle; // (degrees)

    var rotatePoint = polygonsUtm[0][0];

    // polygon must be a multipolygon (array of polygons) because possibly in the process
    // the extraction of the best region divides the original field in two separated polygons

    var multipolygon = [];
    multipolygon.push(polygonsUtm); // init value of multipolygon array: only original field

    var fieldRegions = [];


    do{  // main loop: computes best subregion and then substracts it from the whole field
        
        var angleFrom=0;
        var angleTo=179;
        var angleStep= 1;
        //var winnerAngle = null;

        var bestBlocks = []; // stores the best block for each rotation angle

        // compute area of remaining region
        var totalArea = 0;
        for (var p=0; p<multipolygon.length; p++){
            totalArea += polygonArea(multipolygon[p][0]);
            for (var i=1; i<multipolygon[p].length; i++){
                totalArea -= polygonArea(multipolygon[p][i]);
            }
        }

        var winnerBestBlock = getBestBlock(
            angleFrom,
            angleTo,
            angleStep,
            multipolygon,
            rotatePoint,
            workingWidth,
            thresholdRightAngle,
            thresholdCollinearAngle,
            totalArea
        );

        if (winnerBestBlock == null){ 
            multipolygon = [];
        }
        else{

            angleFrom = winnerBestBlock.angle - 0.5;
            angleTo = winnerBestBlock.angle + 0.6;
            angleStep = 0.1;

            winnerBestBlock = getBestBlock(
                angleFrom,
                angleTo,
                angleStep,
                multipolygon,
                rotatePoint,
                workingWidth,
                thresholdRightAngle,
                thresholdCollinearAngle,
                totalArea
            );
/*
            if (fieldRegions.length > 0) {

                const regionAngles = fieldRegions.map(region => region.angle);

                const closestAngle = regionAngles.reduce((prev, curr) =>
                    Math.abs(curr - winnerBestBlock.angle) < Math.abs(prev - winnerBestBlock.angle) ? curr : prev
                );

                //snap

                if (Math.abs(winnerBestBlock.angle - closestAngle) < 0.5) {

                    angleFrom = closestAngle;
                    angleTo = closestAngle;
                    angleStep = 1;

                    winnerBestBlock = getBestBlock(
                        angleFrom,
                        angleTo,
                        angleStep,
                        multipolygon,
                        rotatePoint,
                        workingWidth,
                        thresholdRightAngle,
                        thresholdCollinearAngle,
                        totalArea
                    );

                }

            }
*/
            // rotate back winner block to 0 degrees
            var rotatedWinnerBlock = rotatePolygon(winnerBestBlock.block.polygonPts, rotatePoint, -winnerBestBlock.angle * Math.PI/180);
            winnerBestBlock.rotatedBlock = rotatedWinnerBlock;
            fieldRegions.push(winnerBestBlock);

            // compute remaining trapezoids joined by graph adjancency
            var connectedTrapezoids = computeRemainingPolygon(winnerBestBlock.trapezoids, winnerBestBlock.block.groupOfTrapezoids);

            // remove polygon that contains best block from multipolygon
            multipolygon.splice(winnerBestBlock.polygonIndex, 1);

            for (var p=0; p<connectedTrapezoids.length; p++){
                // array with trapezoids of each group
                var trap = winnerBestBlock.trapezoids.filter(function(item){
                    return connectedTrapezoids[p].indexOf(item.id.toString()) !== -1;
                });

                var poly = trapezoidsToJsts(trap);
                if (poly){
                    for (var pol=0; pol<poly.length; pol++){
                        for (var ring=0; ring<poly[pol].length; ring++){
                            removeCollinearPoints(poly[pol][ring], 0.5);
                            removeNearPoints(poly[pol][ring], 0.1);
                        }
                        var rotatedPoly = rotatePolygons(poly[pol], rotatePoint, -winnerBestBlock.angle * Math.PI/180);
                        multipolygon.push(rotatedPoly);
                    }
                }
            }

            // removeSpikes was removed during the sub-route union implementation, as it makes it harder to detect adjacent subfields
            //removeSpikes(multipolygon, 3); // chequear si es necesario ahora que los triangulos muy angostos al inicio o al final se agregan al grupo de trapezoides sin considerar los coeficientes de ánguls

        }
        if (fieldRegions.length>=20){
            console.log ("process finished: too many subregions"); 
            multipolygon = [];
        }

    } while(multipolygon.length>0 && fieldRegions.length<20);



    var subFields = fieldRegions.map(region => ({
        polygon: rotatePolygon(region.block.polygonPts, rotatePoint, -region.angle * Math.PI/180),
        workingAngle: (region.angle<90?90-region.angle:270-region.angle) })); // rotate angle 90º and normalize (0-180º)

    //var routePlan = {routesCoord: routeUtm, routesWork: routeWork, workableAreas: workableArea, subFields: subFields };

    return subFields;

    
    // Gets the best block of trapezoids within a specified angle range
    function getBestBlock(
        angleFrom,
        angleTo,
        angleStep,
        multipolygon,
        rotatePoint,
        workingWidth,
        thresholdRightAngle,
        thresholdCollinearAngle,
        totalArea
    ) {

        var bestBlocks = [];

        for (var angle=angleFrom; angle<=angleTo; angle = angle + angleStep ){

            for (var p=0; p<multipolygon.length; p++){
                
                var rotatedPolygonsUtm = rotatePolygons(multipolygon[p], rotatePoint, angle * Math.PI/180);

                var trapezoids = trapezoidation(rotatedPolygonsUtm);
                //var str = graficar();
                mergeTrapezoids(trapezoids, thresholdRightAngle, thresholdCollinearAngle, workingWidth);
                var uniqueGroups = [...new Set(trapezoids.map(item => item.group))];

                // iterate different groups of merged trapezoids and create blocks
                var blocks= [];

                for (var i=0; i<uniqueGroups.length; i++) {
                    var groupOfTrapezoids = trapezoids.filter(item => item.group == uniqueGroups[i] );

// This section was removed during the sub-route union implementation, as it makes it harder to detect adjacent subfields

                    // remove extreme left and right triangle trapezoids if angle is almost vertical (narrow triangles) to avoid adding headlands
/*                    if (groupOfTrapezoids.length>1){
                        if (!(groupOfTrapezoids[0].edge1 instanceof Edge)){
                            if (Math.abs(groupOfTrapezoids[0].edge1.x - groupOfTrapezoids[0].edge2.p1.x) < workingWidth ) { // first trapezoid is a triangle with width < workingwidth => remove
                                groupOfTrapezoids.shift(); // remove first item
                            }
                        }
                    }
                    if (groupOfTrapezoids.length>1){
                        if (!(groupOfTrapezoids[groupOfTrapezoids.length-1].edge2 instanceof Edge)){
                            if (Math.abs(groupOfTrapezoids[groupOfTrapezoids.length-1].edge2.x - groupOfTrapezoids[groupOfTrapezoids.length-1].edge1.p1.x) < workingWidth ) { // first trapezoid is a triangle with width < workingwidth => remove
                                groupOfTrapezoids.pop(); // remove last item
                            }
                        }
                    }*/
                    if (groupOfTrapezoids.length>0){
                        var polygonPts = trapezoidsToPolygon(groupOfTrapezoids);
                        if (polygonPts.length>2){  // a veces hay un trapezoide solo y en los dos extremos es un punto. Revisar!

                            removeCollinearPoints(polygonPts, 0.5);
                            removeNearPoints(polygonPts, 0.1);
                            if (polygonPts.length >= 3) {
                                var cost = 0;
                                if (simplePolygonBuffer(polygonPts, workingWidth/2).type === 'POLYGON'){
                                    if (simplePolygonBuffer(polygonPts, workingWidth).type !== 'MULTIPOLYGON'){  // mainfield must be POLYGON or POLYGON_EMPTY
                                        cost = computePolygonCost(polygonPts, totalArea);
                                    }
                                }
                                if (cost > 0){
                                    blocks.push({ groupOfTrapezoids: groupOfTrapezoids, polygonPts: polygonPts, cost: cost })
                                }
                            }
                        }
                        
                    }
                }
                if (blocks.length>0){
                    var bestBlock = blocks.reduce((max, b) => b.cost > max.cost ? b : max);
                    bestBlocks.push({block: bestBlock, angle: angle, polygonIndex: p, trapezoids: trapezoids});
                }
            }
            
        }

        if (bestBlocks.length == 0){ // Remaining area can't have an area with headlands. End process.
            console.log ("process finished: remaining area too small"); 
            return null;
            //multipolygon = [];
        }
        else{
            var winnerBestBlock = bestBlocks.reduce((max, b) => b.block.cost > max.block.cost ? b : max);
            return winnerBestBlock;
        }

    }



    function computeRemainingPolygon(trapezoids, groupOfTrapezoids){
        
        var groupOfTrapezoidsIds = groupOfTrapezoids.map(a => a.id);

        var remainingTrapezoids = trapezoids.filter(function(item){
            return groupOfTrapezoidsIds.indexOf(item.id) === -1;
        });

        var graph = new Graph();

        for (var t=0; t<remainingTrapezoids.length; t++){
            graph.addNode(remainingTrapezoids[t].id);
        }

        for (var t=0; t<remainingTrapezoids.length; t++){
            for (var l=0; l<remainingTrapezoids[t].leftNeighbours.length; l++){
                if (graph.hasNode(remainingTrapezoids[t].leftNeighbours[l].id)){
                    graph.addEdge(remainingTrapezoids[t].id, remainingTrapezoids[t].leftNeighbours[l].id);
                }
            }
            for (var r=0; r<remainingTrapezoids[t].rightNeighbours.length; r++){
                if (graph.hasNode(remainingTrapezoids[t].rightNeighbours[r].id)){
                    graph.addEdge(remainingTrapezoids[t].id, remainingTrapezoids[t].rightNeighbours[r].id);
                }
            }

        }

        return connectedComponents(graph);

        // merge remaining trapezoids
        

    }


    function mergeTrapezoids(trapezoids, rightAngle, collinearAngle, workingWidth){

        // this function assigns the property 'group' to each trapezoid

        var thresholdRightAngleRad = rightAngle * Math.PI/180;;
        var thresholdCollinearAngleRad = collinearAngle * Math.PI/180;

        // for each trapezoid check if right neighbour can be merged
        for (var i=0; i<trapezoids.length -1 ; i++){  

            if (trapezoids[i].edge2 instanceof Edge  // the trapezoid must have an Edge as right limit (not a point)
                && trapezoids[i].rightNeighbours.length == 1  // it must have only one right neighbour
                && trapezoids[i].rightNeighbours[0].leftNeighbours.length == 1) {// right neighbour must have only one left neighbour
                
                // Verify that the connection between the two trapezoids has a length greater than one workingWidth to prevent bottlenecks

                const lengthEdgeLeftTrapezoid = Math.abs(trapezoids[i].edge2.p1.y - trapezoids[i].edge2.p2.y);
                const lengthEdgeRightTrapezoid = Math.abs(trapezoids[i].rightNeighbours[0].edge1.p1.y - trapezoids[i].rightNeighbours[0].edge1.p2.y);

                if (Math.min(lengthEdgeLeftTrapezoid, lengthEdgeRightTrapezoid) > workingWidth){

                    // Added to merge subfield routes into a single route:
                    // If trapezoid i or its right neighbor is triangular and very narrow, merge them regardless of the angles. This prevents the creation of these types of isolated subfields
                    if (!(trapezoids[i].edge1 instanceof Edge) && (trapezoids[i].edge2.p1.x - trapezoids[i].edge1.x) < 2 * workingWidth
                        || !(trapezoids[i].rightNeighbours[0].edge2 instanceof Edge) && (trapezoids[i].rightNeighbours[0].edge2.x - trapezoids[i].rightNeighbours[0].edge1.p1.x) < 2 * workingWidth) {

                        // right neighbour takes group number from left trapezoid 
                        trapezoids[i].rightNeighbours[0].group = trapezoids[i].group;
                    } 
                    else{

                        var pUpperLeft, pUpperMid, pUpperRight = null;
                        var pLowerLeft, pLowerMid, pLowerRight = null;
                        
                        if (trapezoids[i].edge1 instanceof Edge){
                            if (trapezoids[i].edge1.p1.y>trapezoids[i].edge1.p2.y){
                                pUpperLeft = trapezoids[i].edge1.p1;
                                pLowerLeft = trapezoids[i].edge1.p2;
                            }else{
                                pUpperLeft = trapezoids[i].edge1.p2;
                                pLowerLeft = trapezoids[i].edge1.p1;                    
                            }
                        }else {
                            pUpperLeft = trapezoids[i].edge1;
                            pLowerLeft = trapezoids[i].edge1;
                        }

                        if (trapezoids[i].rightNeighbours[0].edge2 instanceof Edge){
                            if (trapezoids[i].rightNeighbours[0].edge2.p1.y>trapezoids[i].rightNeighbours[0].edge2.p2.y){
                                pUpperRight = trapezoids[i].rightNeighbours[0].edge2.p1;
                                pLowerRight = trapezoids[i].rightNeighbours[0].edge2.p2;
                            }else{
                                pUpperRight = trapezoids[i].rightNeighbours[0].edge2.p2;
                                pLowerRight = trapezoids[i].rightNeighbours[0].edge2.p1;
                            }
                        }else {
                            pUpperRight = trapezoids[i].rightNeighbours[0].edge2;
                            pLowerRight = trapezoids[i].rightNeighbours[0].edge2;
                        }

                        if (trapezoids[i].edge2.p1.y>trapezoids[i].edge2.p2.y){
                            pUpperMid = trapezoids[i].edge2.p1;
                            pLowerMid = trapezoids[i].edge2.p2;
                        }else{
                            pUpperMid = trapezoids[i].edge2.p2;
                            pLowerMid = trapezoids[i].edge2.p1;
                        }

                        var upperLeftAngle = Math.atan((pUpperLeft.y-pUpperMid.y)/(pUpperLeft.x-pUpperMid.x));
                        var lowerLeftAngle = Math.atan((pLowerLeft.y-pLowerMid.y)/(pLowerLeft.x-pLowerMid.x));

                        var upperRightAngle = Math.atan((pUpperRight.y-pUpperMid.y)/(pUpperRight.x-pUpperMid.x));
                        var lowerRightAngle = Math.atan((pLowerRight.y-pLowerMid.y)/(pLowerRight.x-pLowerMid.x));


                        var upperAngle = Math.atan2(pUpperRight.y - pUpperMid.y, pUpperRight.x - pUpperMid.x) + Math.atan2(pUpperLeft.y - pUpperMid.y, pUpperMid.x - pUpperLeft.x);
                        var lowerAngle = Math.atan2(pLowerRight.y - pLowerMid.y, pLowerRight.x - pLowerMid.x) + Math.atan2(pLowerLeft.y - pLowerMid.y, pLowerMid.x - pLowerLeft.x);

                        upperAngle = Math.abs(upperAngle);
                        lowerAngle = Math.abs(lowerAngle);

                        // angle conditions to merge

                        if ( Math.abs(upperLeftAngle) < thresholdRightAngleRad &&  
                                Math.abs(lowerLeftAngle) < thresholdRightAngleRad &&  
                                Math.abs(upperRightAngle) < thresholdRightAngleRad &&  
                                Math.abs(lowerRightAngle) < thresholdRightAngleRad ||
                                Math.abs(upperAngle) < thresholdCollinearAngleRad &&
                                Math.abs(lowerAngle) < thresholdCollinearAngleRad ){

                            // right neighbour takes group number from left trapezoid 
                            trapezoids[i].rightNeighbours[0].group = trapezoids[i].group;
                        }
                    }
                }
            }

        }
    }

    function trapezoidsToPolygon(trapezoids){

        var polygonPoints = [];

        // add one or two points depending on left trapezoid starts with point or edge
        if (trapezoids[0].edge1 instanceof Edge){
            if (trapezoids[0].edge1.p1.y>trapezoids[0].edge1.p2.y){
                polygonPoints.push(trapezoids[0].edge1.p2);
                polygonPoints.push(trapezoids[0].edge1.p1);
            }else{
                polygonPoints.push(trapezoids[0].edge1.p1);
                polygonPoints.push(trapezoids[0].edge1.p2);
            }
        }
        else{
            polygonPoints.push(trapezoids[0].edge1);
        }
        // add intermediate upper points
        for (var i=0; i<trapezoids.length-1; i++){ 
            if (trapezoids[i].edge2.p1.y>trapezoids[i].edge2.p2.y)
                polygonPoints.push(trapezoids[i].edge2.p1);
            else
                polygonPoints.push(trapezoids[i].edge2.p2);
        }
        // add right extreme trapezoid point/points
        if (trapezoids[trapezoids.length-1].edge2 instanceof Edge){
            if (trapezoids[trapezoids.length-1].edge2.p1.y > trapezoids[trapezoids.length-1].edge2.p2.y){
                polygonPoints.push(trapezoids[trapezoids.length-1].edge2.p1);
                polygonPoints.push(trapezoids[trapezoids.length-1].edge2.p2);
            }
            else{
                polygonPoints.push(trapezoids[trapezoids.length-1].edge2.p2);
                polygonPoints.push(trapezoids[trapezoids.length-1].edge2.p1);
            }
        }
        else{
            polygonPoints.push(trapezoids[trapezoids.length-1].edge2);
        }
        // iterate trapezoids from right to left to add intermediate lower points
        for (var i=trapezoids.length-2; i>=0; i--){
            if (trapezoids[i].edge2.p1.y > trapezoids[i].edge2.p2.y)
                polygonPoints.push(trapezoids[i].edge2.p2);
            else
                polygonPoints.push(trapezoids[i].edge2.p1);
        }

        return polygonPoints;

    }

    function trapezoidsToHeadlandPolygon(polygonPts, trapezoids){
        
        var polygonPoints = [];
        var p1, p2, p3, p4;
        var noHeadland;
        var h1;
        var h2;
        var upperHeadland;
        var lowerHeadland;
        var upperHw, lowerHw;
        var prevHeadland;  
        var pRight;
        var pLeft;


        // 1) left extreme trapezoid

        noHeadland = false;
        if (trapezoids[0].edge1 instanceof Edge){ // left trapezoid starts with edge (not a point)
            //  p1--p3
            //  |    |
            //  p2--p4

            // set p1 = upper point
            if (trapezoids[0].edge1.p1.y>trapezoids[0].edge1.p2.y){
                p1 = trapezoids[0].edge1.p1;
                p2 = trapezoids[0].edge1.p2;
            }
            else{
                p1 = trapezoids[0].edge1.p2;
                p2 = trapezoids[0].edge1.p1;
            }
        }
        else{ // left trapezoid is a triangle: let p1=p2

            //          p3
            //  p1=p2<  |
            //          p4

            p1 = trapezoids[0].edge1;
            p2 = p1; 
        }

        if (trapezoids[0].edge2 instanceof Edge){ // left trapezoid ends with edge (not a point)

            // set p3 = upper point
            if (trapezoids[0].edge2.p1.y>trapezoids[0].edge2.p2.y){
                p3 = trapezoids[0].edge2.p1;
                p4 = trapezoids[0].edge2.p2;
            }
            else{
                p3 = trapezoids[0].edge2.p2;
                p4 = trapezoids[0].edge2.p1;
            }
        }
        else{ // left trapezoid is unique trapezoid. It can ends with a point
            p3 = trapezoids[0].edge2;
            p4 = p3; 
        }

        if (headlandWidth == -1){ // variable headland width depending on angle track-border
            upperHw = computeHeadlandWidth(p1, p3, turningRadius, workingWidth);
            lowerHw = computeHeadlandWidth(p2, p4, turningRadius, workingWidth);
        }
        else{
            upperHw = headlandWidth;
            lowerHw = headlandWidth;
        }

        if (trapezoids[0].edge1 instanceof Edge){ // left trapezoid starts with edge (not a point)
            // check if there should be a headland-zero at left (vertical edge)
            var l1 = Math.sqrt((p1.x-p3.x)*(p1.x-p3.x)+(p1.y-p3.y)*(p1.y-p3.y));
            h1 = {x: p1.x, y: p1.y + upperHw * l1/ (p1.x-p3.x)}; // intersection of upper headland line with left vertical segment

            var l2 = Math.sqrt((p2.x-p4.x)*(p2.x-p4.x)+(p2.y-p4.y)*(p2.y-p4.y));
            h2 = {x: p2.x, y: p2.y - lowerHw * l2/ (p2.x-p4.x)}; // intersection of lower headland line with left vertical segment

            if (h1.y > h2.y){  // there is a left parallel edge after substracting headland width above and below. Set headland width = 0
                noHeadland = true;
            }
        }

        upperHeadland = computeParallelLine(p1, p3, upperHw);
        lowerHeadland = computeParallelLine(p2, p4, -lowerHw);
        if (noHeadland){
            //if (isPointInPolygon(h2, polygonPts))
                polygonPoints.push(h2);
            //if (isPointInPolygon(h1, polygonPts))
                polygonPoints.push(h1);
        }
        else{
            var inter = intersectLineLine2(
                upperHeadland[0],
                upperHeadland[1],
                lowerHeadland[0],
                lowerHeadland[1]);
            if (inter.length>0)
                if (isPointInPolygon(inter[0], polygonPts))
                    polygonPoints.push(inter[0]);
        }

        // 2) add intermediate upper points

            //  ______pLeft___pRigth
            //  |       |       |
            //  | prev  |   i   |
            //  |_______|_______|

        prevHeadland = upperHeadland;  
        pLeft = p3;

        for (var i=1; i<trapezoids.length; i++){
            /*
            if (trapezoids[i].edge2.p1.y>trapezoids[i].edge2.p2.y)
                pRight=trapezoids[i].edge2.p1;
            else
                pRight=trapezoids[i].edge2.p2;
            */

            if (trapezoids[i].edge2 instanceof Edge){ // left trapezoid ends with edge (not a point)
                if (trapezoids[i].edge2.p1.y>trapezoids[i].edge2.p2.y)
                    pRight=trapezoids[i].edge2.p1;
                else
                    pRight=trapezoids[i].edge2.p2;
            }
            else{ // left trapezoid is unique trapezoid. It can ends with a point
                pRight = trapezoids[i].edge2;
            }

            // set headland width
            if (headlandWidth == -1){ // variable headland width depending on angle track-border
                upperHw = computeHeadlandWidth(pLeft, pRight, turningRadius, workingWidth);
            }
            else{
                upperHw = headlandWidth;
            }

            // compute headland line of current trapezoid i
            var upperHeadland = computeParallelLine(pLeft, pRight, upperHw);
            
            // compute prev and current trapez headland line intersection
            var inter = intersectLineLine2(
                prevHeadland[0],
                prevHeadland[1],
                upperHeadland[0],
                upperHeadland[1]);
            
            // add intersection point to polygon
            if (inter.length>0)
                if (isPointInPolygon(inter[0], polygonPts))
                    polygonPoints.push(inter[0]);

            // set values for next iteration
            prevHeadland = upperHeadland;
            pLeft = pRight;
        }


        // 3) right extreme trapezoid

        noHeadland = false;
        if (trapezoids[trapezoids.length-1].edge1 instanceof Edge){ // right trapezoid start with edge (not a point)

            // set p1 = upper point
            if (trapezoids[trapezoids.length-1].edge1.p1.y>trapezoids[trapezoids.length-1].edge1.p2.y){
                p1 = trapezoids[trapezoids.length-1].edge1.p1;
                p2 = trapezoids[trapezoids.length-1].edge1.p2;
            }
            else{
                p1 = trapezoids[trapezoids.length-1].edge1.p2;
                p2 = trapezoids[trapezoids.length-1].edge1.p1;
            }
        }
        else{ // right trapezoid is unique trapezoid. It can start with a point
            p1 = trapezoids[trapezoids.length-1].edge1;
            p2 = p1; 
        }

        if (trapezoids[trapezoids.length-1].edge2 instanceof Edge){ // right trapezoid ends with edge (not a point)
            //  p1--p3
            //  |    |
            //  p2--p4

            // set p3 = upper point
            if (trapezoids[trapezoids.length-1].edge2.p1.y>trapezoids[trapezoids.length-1].edge2.p2.y){
                p3 = trapezoids[trapezoids.length-1].edge2.p1;
                p4 = trapezoids[trapezoids.length-1].edge2.p2;
            }
            else{
                p3 = trapezoids[trapezoids.length-1].edge2.p2;
                p4 = trapezoids[trapezoids.length-1].edge2.p1;
            }
        }
        else{ // right trapezoid is a triangle: let p3=p4

            //    p1
            //    |  >p3=p4
            //    p2

            p3 = trapezoids[trapezoids.length-1].edge2;
            p4 = p3; 
        }

        if (headlandWidth == -1){ // variable headland width depending on angle track-border
            upperHw = computeHeadlandWidth(p1, p3, turningRadius, workingWidth);
            lowerHw = computeHeadlandWidth(p2, p4, turningRadius, workingWidth);
        }
        else{
            upperHw = headlandWidth;
            lowerHw = headlandWidth;
        }

        if (trapezoids[trapezoids.length-1].edge2 instanceof Edge){ // right trapezoid ends with edge (not a point)
            // check if there should be a headland-zero at right (vertical edge)
            var l1 = Math.sqrt((p1.x-p3.x)*(p1.x-p3.x)+(p1.y-p3.y)*(p1.y-p3.y));
            h1 = {x: p3.x, y: p3.y + upperHw * l1/ (p1.x-p3.x)}; // intersection of upper headland line with right vertical segment

            var l2 = Math.sqrt((p2.x-p4.x)*(p2.x-p4.x)+(p2.y-p4.y)*(p2.y-p4.y));
            h2 = {x: p4.x, y: p4.y - lowerHw * l2/ (p2.x-p4.x)}; // intersection of lower headland line with right vertical segment

            if (h1.y > h2.y){  // there is a right parallel edge after substracting headland width above and below. Set headland width = 0
                noHeadland = true;
            }
        }

        upperHeadland = computeParallelLine(p1, p3, upperHw);
        lowerHeadland = computeParallelLine(p2, p4, -lowerHw);
        if (noHeadland){
            //if (isPointInPolygon(h1, polygonPts))
                polygonPoints.push(h1);
            //if (isPointInPolygon(h2, polygonPts))
                polygonPoints.push(h2);
        }
        else{
            var inter = intersectLineLine2(
                upperHeadland[0],
                upperHeadland[1],
                lowerHeadland[0],
                lowerHeadland[1]);
            if (inter.length>0)
                if (isPointInPolygon(inter[0], polygonPts))
                    polygonPoints.push(inter[0]);
        }


        // 4) iterate trapezoids from right to left to add intermediate lower points

            //     _______________
            //    |       |       |
            //    |   i   | prev  |
            //    |       |       |
            //  pLeft___pRight____|

        prevHeadland = lowerHeadland;  
        pRight = p2;

        for (var i=trapezoids.length-2; i>=0; i--){
            /*
            if (trapezoids[i].edge1.p1.y>trapezoids[i].edge1.p2.y)
                pLeft=trapezoids[i].edge1.p2;
            else
                pLeft=trapezoids[i].edge1.p1;
            */

            if (trapezoids[i].edge1 instanceof Edge){
                if (trapezoids[i].edge1.p1.y>trapezoids[i].edge1.p2.y)
                    pLeft=trapezoids[i].edge1.p2;
                else
                    pLeft=trapezoids[i].edge1.p1;
            }
            else{
                pLeft=trapezoids[i].edge1;
            }

            // set headland width
            if (headlandWidth == -1){ // variable headland width depending on angle track-border
                lowerHw = computeHeadlandWidth(pLeft, pRight, turningRadius, workingWidth);
            }
            else{
                lowerHw = headlandWidth;
            }

            // compute headland line of current trapezoid i
            var lowerHeadland = computeParallelLine(pLeft, pRight, -lowerHw);
            
            // compute prev and current trapez headland line intersection
            var inter = intersectLineLine2(
                prevHeadland[0],
                prevHeadland[1],
                lowerHeadland[0],
                lowerHeadland[1]);
            
            // add intersection point to polygon
            if (inter.length>0)
                if (isPointInPolygon(inter[0], polygonPts))
                    polygonPoints.push(inter[0]);

            // set values for next iteration
            prevHeadland = lowerHeadland;
            pRight = pLeft;
        }
    /*
        // 5) close the polygon using lowerHeadland computed at the beginning

        var inter = intersectLineLine2(
            prevHeadland[0],
            prevHeadland[1],
            initLowerHeadland[0],
            initLowerHeadland[1]);

            // add intersection point to polygon
            if (inter.length>0)
                if (isPointInPolygon(inter[0], polygonPts))
                    polygonPoints.push(inter[0]);
    */
        return polygonPoints;
    }
/*
    function getMergedTrapezoidsOffsetHeadland(polygonPts){
        // convert polygon to geojson
        var polygonPtsHeadlandGeoJson = ringToGeojsonPolygon(polygonPts);
        var res = polygonBuffer(polygonPtsHeadlandGeoJson, headlandWidth).coordinates;
        return res;
    }
*/

    function computeHeadlandWidth(p1, p2, turningRadius, workingWidth){
        var borderAngle = Math.atan((p2.y-p1.y)/(p2.x-p1.x));
        var w = ( Math.sin(borderAngle) + 1) * turningRadius + workingWidth/2; // pl_11_607_b3.pdf (pag 414) 
        return w;
    }

    function computeParallelLine(p1, p2, offset){
        // positive offset for line below the original one
        var l = Math.sqrt((p1.x-p2.x)*(p1.x-p2.x)+(p1.y-p2.y)*(p1.y-p2.y));
        var p3 = {x: p1.x + offset * (p2.y-p1.y) / l, y: p1.y + offset * (p1.x-p2.x) / l};
        var p4 = {x: p2.x + offset * (p2.y-p1.y) / l, y: p2.y + offset * (p1.x-p2.x) / l};
        return [p3, p4];
    }



/*
    function removeBowties(poly){

        var geoJsonPoly = ringToGeojsonPolygon(poly);

        var result = simplepolygon(geoJsonPoly);

        var resultFiltered = result.features.filter(function (el) {
            return el.properties.winding == -1;
            });

        if (resultFiltered.length > 1){
            console.log("Warning: more than one polygon with winding -1 after removing bowties");
            return [];
        }
        else if(resultFiltered.length == 0){
            return []; // area too small. Resulting polygon with headland becomes CCW
        }
        else{
            var resGeoJsonCoordinates = resultFiltered[0].geometry.coordinates[0];
            // convert geoJson back
            resGeoJsonCoordinates.pop(); // remove last element
            var res = resGeoJsonCoordinates.map(function(pt) { 
                return { 
                    x: pt[0], 
                    y: pt[1] 
                }; 
                });

            return res;
        }

    }
*/

    function computePolygonCost(polygonPoints, remainingArea){

        var routeLenght = 0;
        var numberOfTurns = 0;

        var xSwath = polygonPoints[0].x + workingWidth/2; // left limit of polygon + half working width
        
        var xMax =Math.max.apply(Math, polygonPoints.map(function(o) { return o.x; })) // maximum x value of all polygon points
        // var str="";
        while (true) {

            var intersectionPoints = intersectLinePolygon( {x: xSwath, y:0}, {x: xSwath, y: 10000000}, polygonPoints );

            if (intersectionPoints.length==0 || (xMax - xSwath)< workingWidth/2 )
                break;

            var swathLenght = Math.abs(intersectionPoints[0].y - intersectionPoints[1].y);
            routeLenght += swathLenght;
            numberOfTurns++;
            xSwath += workingWidth;
            //str +=  intersectionPoints[0].x + ',' + intersectionPoints[0].y + '\n';
            //str +=  intersectionPoints[1].x + ',' + intersectionPoints[1].y + '\n';
        };
        
        // Cost = α ∗ (Area of the block/Total area remaining in field) +
        //        β ∗ ((Effective distance covered/(Moving time + Turning time)) / Average Straightline Speed)

        var a = polygonArea(polygonPoints) / remainingArea;
        
        var cost = 0;
        if (routeLenght>0){
            var movingTime = routeLenght/workingSpeed;
            var totalTurningTime = numberOfTurns * turningTime;
            var b = (routeLenght/(movingTime + totalTurningTime))/ workingSpeed;
            cost = areaCostCoefficient*a + timeCostCoefficient*b;
        }

        return cost;
    }

}

